<div
    class="border-border bg-surface text-text-primary flex h-screen w-full flex-col border-r select-none">
    <!-- Header / Brand section -->
    <div
        class="border-border flex items-center justify-between border-b px-5 py-4">
        @if (!isCollapsed) {
            <a
                [routerLink]="['/dashboard/home']"
                class="group flex cursor-pointer items-center gap-2.5">
                <img
                    src="assets/logo/hairstyleclub-icon.png"
                    class="h-8 w-8 object-contain transition-transform group-hover:scale-105"
                    alt="Hair Style Club" />
                <span
                    class="text-text-primary text-xl font-bold tracking-tight">
                    Shop
                </span>
            </a>
        } @else {
            <a
                [routerLink]="['/dashboard/home']"
                class="mx-auto flex h-9 w-9 cursor-pointer items-center justify-center">
                <img
                    src="assets/logo/hairstyleclub-icon.png"
                    class="h-7 w-7 object-contain"
                    alt="Hair Style Club" />
            </a>
        }
    </div>

    <!-- Scrollable navigation groups -->
    <div class="scrollbar-hide flex-1 overflow-y-auto px-3 py-3">
        @if (!isCollapsed) {
            <div class="space-y-4">
                @for (
                    group of filteredNavigationGroups;
                    track group.label;
                    let groupIdx = $index
                ) {
                    <div>
                        @if (groupIdx > 0) {
                            <div
                                fontSpanish
                                class="text-primary px-3 pt-3 pb-1.5 text-[11px] font-bold tracking-wider uppercase">
                                {{ group.label | transloco }}
                            </div>
                        }
                        <ul class="space-y-0.5">
                            @for (item of group.items; track item.routerLink) {
                                <li>
                                    <a
                                        [routerLink]="[item.routerLink]"
                                        routerLinkActive="bg-primary-soft text-primary font-semibold"
                                        [routerLinkActiveOptions]="{
                                            exact:
                                                item.routerLink ===
                                                '/dashboard/home',
                                        }"
                                        #rla="routerLinkActive"
                                        class="text-text-primary hover:bg-surface-muted flex items-center gap-3.5 rounded-xl px-3.5 py-2 text-sm font-medium transition-all">
                                        <span
                                            class="pi {{
                                                item.icon
                                            }} text-lg transition-colors"
                                            [class.text-primary]="rla.isActive"
                                            [class.text-text-secondary]="
                                                !rla.isActive
                                            ">
                                        </span>
                                        <span fontSpanish class="truncate">
                                            {{ item.label | transloco }}
                                        </span>
                                    </a>
                                </li>
                            }
                        </ul>
                    </div>
                }
            </div>
        } @else {
            <ul class="space-y-1">
                @for (group of filteredNavigationGroups; track group.label) {
                    @for (item of group.items; track item.routerLink) {
                        <li>
                            <a
                                [routerLink]="[item.routerLink]"
                                routerLinkActive="bg-primary-soft text-primary font-semibold"
                                [routerLinkActiveOptions]="{
                                    exact:
                                        item.routerLink === '/dashboard/home',
                                }"
                                #rla="routerLinkActive"
                                class="hover:bg-surface-muted mx-auto flex h-10 w-10 items-center justify-center rounded-xl transition-all"
                                [pTooltip]="item.label | transloco"
                                tooltipPosition="right">
                                <span
                                    class="pi {{ item.icon }} text-lg"
                                    [class.text-primary]="rla.isActive"
                                    [class.text-text-secondary]="!rla.isActive">
                                </span>
                            </a>
                        </li>
                    }
                }
            </ul>
        }
    </div>
</div>
